/**
 * Workbench 工作台注入标识
 *
 * @public
 */
const IWorkbench = Symbol('service:workbench');

export { IWorkbench };
//# sourceMappingURL=workbench.interface.js.map
